import React from 'react';
export function Hero() {
  return <section className="min-h-[auto] md:min-h-screen pt-[100px] md:pt-[160px] pb-10 md:pb-[100px] px-4 md:px-12 relative overflow-hidden flex items-center z-10" aria-label="Portada principal" data-id="element-92">
      {/* BG layers */}
      <div className="absolute inset-0 z-0" aria-hidden="true" data-id="element-93">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,rgba(255,215,0,0.06)_0%,transparent_60%),radial-gradient(ellipse_60%_40%_at_80%_80%,rgba(0,245,255,0.04)_0%,transparent_50%),radial-gradient(ellipse_40%_40%_at_20%_60%,rgba(0,255,65,0.03)_0%,transparent_50%),linear-gradient(180deg,#000_0%,#03070f_50%,#000_100%)]" data-id="element-94" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,215,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,215,0,0.03)_1px,transparent_1px)] bg-[size:60px_60px] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,black_30%,transparent_80%)]" data-id="element-95" />
        <div className="absolute top-[10%] -left-[10%] w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(255,215,0,0.07)_0%,transparent_70%)] animate-orb-drift" data-id="element-96" />
        <div className="absolute bottom-[5%] -right-[5%] w-[400px] h-[400px] bg-[radial-gradient(circle,rgba(0,245,255,0.06)_0%,transparent_70%)] animate-orb-drift-reverse" data-id="element-97" />
      </div>

      {/* Main content — two-column layout */}
      <div className="w-full max-w-7xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-16 lg:gap-20" data-id="element-98">
        {/* LEFT — Text content */}
        <div className="flex-1 max-w-[600px] text-center md:text-left" data-id="element-99">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2.5 mb-4 md:mb-8 opacity-0 animate-slide-in-left" style={{
          animationDelay: '0.2s',
          animationFillMode: 'forwards'
        }} data-id="element-100">
            <div className="w-8 h-px bg-gold" aria-hidden="true" data-id="element-101" />
            <span className="text-[0.55rem] md:text-[0.7rem] font-semibold tracking-[3px] md:tracking-[4px] uppercase text-gold" data-id="element-102">
              Arquitectura Digital · Escala Global · 2025
            </span>
            <div className="w-1.5 h-1.5 rounded-full bg-cyan animate-pulse-glow" aria-hidden="true" data-id="element-103" />
          </div>

          {/* Headline */}
          <h1 className="font-display leading-[0.85] md:leading-[0.9] tracking-[2px] mb-4 md:mb-8 opacity-0 animate-slide-in-left" style={{
          animationDelay: '0.4s',
          animationFillMode: 'forwards'
        }} data-id="element-104">
            <span className="block text-[clamp(1.5rem,4vw,4rem)] text-text-muted tracking-[6px] md:tracking-[8px] font-light mb-1" data-id="element-105">
              LA
            </span>
            <span className="block text-[clamp(3rem,8vw,8rem)] text-white drop-shadow-[0_0_60px_rgba(255,255,255,0.1)]" data-id="element-106">
              MENTALIDAD
            </span>
            <span className="block text-[clamp(3rem,8vw,8rem)] bg-gradient-to-br from-gold-dark via-gold to-gold-light text-gradient bg-[length:200%_100%] animate-gold-shimmer drop-shadow-[0_0_20px_rgba(255,215,0,0.4)]" data-id="element-107">
              DEL CREADOR
            </span>
            <span className="block text-[clamp(3rem,8vw,8rem)] text-white" data-id="element-108">
              MILLONARIO
            </span>
            <span className="block text-[clamp(1.2rem,3vw,3rem)] text-cyan tracking-[4px] md:tracking-[6px] drop-shadow-[0_0_30px_rgba(0,245,255,0.2)]" data-id="element-109">
              CON I.A.
            </span>
          </h1>

          {/* Subtitle */}
          <p className="font-text text-[0.85rem] md:text-[clamp(0.9rem,1.5vw,1.2rem)] text-text-silver leading-[1.6] md:leading-[1.8] max-w-[580px] mb-5 md:mb-12 mx-auto md:mx-0 opacity-0 animate-slide-in-left" style={{
          animationDelay: '0.6s',
          animationFillMode: 'forwards'
        }} data-id="element-110">
            No aprenderás a "crear contenido". Aprenderás a{' '}
            <strong className="text-gold" data-id="element-111">
              construir infraestructura digital de alto ticket
            </strong>{' '}
            usando herramientas de IA de élite — sin escribir una sola línea de
            código.
          </p>

          {/* Book cover — MOBILE ONLY */}
          <div className="flex md:hidden justify-center mb-5 opacity-0 animate-fade-up" style={{
          animationDelay: '0.7s',
          animationFillMode: 'forwards'
        }} data-id="element-112">
            <div className="relative" data-id="element-113">
              <div className="absolute inset-0 -m-6 bg-[radial-gradient(ellipse_70%_70%_at_50%_50%,rgba(255,215,0,0.15)_0%,rgba(0,245,255,0.08)_40%,transparent_70%)] blur-2xl" aria-hidden="true" data-id="element-114" />
              <img src="https://cdn.magicpatterns.com/uploads/rCswHckZyLzzunM6KxJ9nP/ChatGPT_Image_11_mar_2026,_12_35_37_a.m..png" alt="Portada del ebook La Mentalidad del Creador Millonario con Inteligencia Artificial" className="relative w-[200px] max-w-full rounded-lg animate-book-float drop-shadow-[0_0_40px_rgba(255,215,0,0.3)] [filter:drop-shadow(0_0_60px_rgba(0,245,255,0.15))]" style={{
              transform: 'perspective(800px) rotateY(-5deg)'
            }} data-id="element-115" />
            </div>
          </div>

          {/* Skull divider */}
          <div className="flex items-center gap-3 mb-5 md:mb-12 justify-center md:justify-start opacity-0 animate-slide-in-left" style={{
          animationDelay: '0.7s',
          animationFillMode: 'forwards'
        }} aria-hidden="true" data-id="element-116">
            <div className="flex-1 max-w-[80px] md:max-w-[120px] h-px bg-gradient-to-r from-gold-dark to-transparent" data-id="element-117" />
            <span className="text-lg md:text-xl drop-shadow-[0_0_8px_rgba(255,215,0,0.3)]" data-id="element-118">
              💀
            </span>
            <div className="flex-1 max-w-[80px] md:max-w-[120px] h-px bg-gradient-to-l from-gold-dark to-transparent" data-id="element-119" />
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-4 md:gap-10 mb-5 md:mb-12 justify-center md:justify-start opacity-0 animate-slide-in-left" style={{
          animationDelay: '0.8s',
          animationFillMode: 'forwards'
        }} aria-label="Métricas del producto" data-id="element-120">
            <div className="flex flex-col" data-id="element-121">
              <span className="font-display text-[2rem] md:text-[2.5rem] leading-none text-gold drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-122">
                7
              </span>
              <span className="text-[0.6rem] md:text-[0.7rem] uppercase tracking-[2px] text-text-muted mt-0.5" data-id="element-123">
                Módulos
              </span>
            </div>
            <div className="flex flex-col" data-id="element-124">
              <span className="font-display text-[2rem] md:text-[2.5rem] leading-none text-gold drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-125">
                30
              </span>
              <span className="text-[0.6rem] md:text-[0.7rem] uppercase tracking-[2px] text-text-muted mt-0.5" data-id="element-126">
                Días
              </span>
            </div>
            <div className="flex flex-col" data-id="element-127">
              <span className="font-display text-[2rem] md:text-[2.5rem] leading-none text-gold drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-128">
                6
              </span>
              <span className="text-[0.6rem] md:text-[0.7rem] uppercase tracking-[2px] text-text-muted mt-0.5" data-id="element-129">
                Herramientas
              </span>
            </div>
            <div className="flex flex-col" data-id="element-130">
              <span className="font-display text-[2rem] md:text-[2.5rem] leading-none text-gold drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-131">
                $0
              </span>
              <span className="text-[0.6rem] md:text-[0.7rem] uppercase tracking-[2px] text-text-muted mt-0.5" data-id="element-132">
                Código
              </span>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center md:items-start gap-3 md:gap-4 opacity-0 animate-slide-in-left" style={{
          animationDelay: '1s',
          animationFillMode: 'forwards'
        }} data-id="element-133">
            <a href="#oferta" className="cta-primary inline-flex items-center gap-3 bg-gradient-to-r from-gold-dark via-gold to-gold-light bg-[length:300%_100%] text-black px-6 md:px-12 py-3.5 md:py-5 rounded-md font-body text-[0.78rem] md:text-[1rem] font-extrabold tracking-[2px] uppercase no-underline" aria-label="Convertirme en Arquitecto Digital" data-id="element-134">
              CONVERTIRME EN ARQUITECTO DIGITAL
              <span className="cta-arrow text-lg" data-id="element-135">→</span>
            </a>
            <span className="flex items-center gap-2 text-[0.65rem] md:text-[0.75rem] text-text-muted tracking-[1px]" data-id="element-136">
              <span className="w-1.5 h-1.5 rounded-full bg-matrix shadow-[0_0_8px_#00FF41]" aria-hidden="true" data-id="element-137" />
              Acceso inmediato · Garantía 7 días · Pago único $14.94
            </span>
          </div>
        </div>

        {/* RIGHT — Book cover (DESKTOP ONLY) */}
        <div className="hidden md:flex flex-1 justify-center items-center opacity-0" style={{
        animation: 'heroImageReveal 1s ease forwards',
        animationDelay: '0.8s'
      }} data-id="element-138">
          <div className="relative" data-id="element-139">
            <div className="absolute -inset-16 bg-[radial-gradient(ellipse_60%_60%_at_50%_50%,rgba(255,215,0,0.12)_0%,rgba(0,245,255,0.06)_50%,transparent_70%)] blur-3xl animate-glow-pulse" aria-hidden="true" data-id="element-140" />
            <div className="absolute -inset-10 bg-[radial-gradient(ellipse_50%_70%_at_60%_40%,rgba(0,245,255,0.08)_0%,transparent_60%)] blur-2xl" aria-hidden="true" data-id="element-141" />
            <img src="https://cdn.magicpatterns.com/uploads/rCswHckZyLzzunM6KxJ9nP/ChatGPT_Image_11_mar_2026,_12_35_37_a.m..png" alt="Portada del ebook La Mentalidad del Creador Millonario con Inteligencia Artificial" className="relative w-[420px] max-w-full rounded-lg animate-book-float" style={{
            transform: 'perspective(1000px) rotateY(-6deg)',
            filter: 'drop-shadow(0 0 40px rgba(255,215,0,0.3)) drop-shadow(0 0 80px rgba(0,245,255,0.15)) drop-shadow(0 20px 60px rgba(0,0,0,0.5))'
          }} data-id="element-142" />
          </div>
        </div>
      </div>

      {/* Scroll indicator — hidden on mobile */}
      <div className="absolute bottom-8 md:bottom-10 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 opacity-40 z-10" style={{
      animation: 'scrollBounce 2s ease infinite'
    }} aria-hidden="true" data-id="element-143">
        <span className="text-[0.55rem] tracking-[3px] text-gold uppercase" data-id="element-144">
          Scroll
        </span>
        <div className="w-px h-10 bg-gradient-to-b from-gold to-transparent" data-id="element-145" />
      </div>

      <style data-id="element-146">{`
        @keyframes heroImageReveal {
          from { opacity: 0; transform: translateX(60px) scale(0.95); }
          to { opacity: 1; transform: translateX(0) scale(1); }
        }
      `}</style>
    </section>;
}